import { render } from "./Indicadores.vue?vue&type=template&id=69da090c&scoped=true"
import script from "./Indicadores.vue?vue&type=script&lang=js"
export * from "./Indicadores.vue?vue&type=script&lang=js"

import "./Indicadores.vue?vue&type=style&index=0&id=69da090c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69da090c"]])

export default __exports__